import SearchBar from './SearchBar'

interface Props {
  onSelectRegion: (regionId: string) => void
  onSelectFigure: (figureId: string) => void
  onResetHome: () => void                // clears all selections, returns to the welcome state
  hasAnySelection: boolean               // when true, the visible "Reset" affordance appears
  searchResetKey: number                 // bumping this remounts SearchBar so its text input clears
}

export default function Header({ onSelectRegion, onSelectFigure, onResetHome, hasAnySelection, searchResetKey }: Props) {
  return (
    <header className="border-b border-ink-300/10 bg-parchment-50/70 backdrop-blur-sm relative z-10">
      <div className="max-w-[1800px] mx-auto px-6 py-4 flex items-baseline gap-6 flex-wrap">
        <div>
          {/* Clicking the brand returns to the landing/welcome state. */}
          <button
            onClick={onResetHome}
            className="block text-left group"
            title="Return to the welcome view (clears your place and time selection)"
            aria-label="Bhāvan Atlas — return to home"
          >
            <h1 className="font-display text-2xl sm:text-3xl text-ink-300 leading-none tracking-wide iast group-hover:text-saffron-500 transition-colors">
              Bhāvan Atlas
            </h1>
            <p className="text-xs text-ink-50 mt-1 group-hover:text-ink-100 transition-colors">
              India through Majumdar's eyes — a place and time explorer
            </p>
          </button>
        </div>
        {hasAnySelection && (
          <button
            onClick={onResetHome}
            className="text-xs px-2.5 py-1.5 rounded bg-parchment-200 hover:bg-saffron-50 hover:text-saffron-500 text-ink-100 border border-ink-300/8 transition-colors self-center"
            title="Clear place and time, return to the welcome view"
          >
            ↶ Reset to home
          </button>
        )}
        <div className="flex-1 min-w-[260px]">
          <SearchBar key={searchResetKey} onSelectRegion={onSelectRegion} onSelectFigure={onSelectFigure} />
        </div>
        <div className="text-xs text-ink-50 hidden md:block self-center">
          <em className="italic">History &amp; Culture of the Indian People</em> · 11 vols.
        </div>
      </div>
    </header>
  )
}
